/**
 * Legacy EntitlementsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.entitlementsApi`) keep resolving.
 *
 * The actual EntitlementsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/entitlements/entitlements-api.service.ts
 */
angular.module("acme.common.service.entitlementsApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
